import React, { useState } from 'react';
import { getRuta } from '../../../../helpers/Helpers';
import {
	BotonGenerar,
	FormularioSelector,
	SelectorGestor
} from '../../../../components/reportes/selector';

const SelectorSaldosCarteraByGestor = () => {
	const [selectedGestor, setSelectedGestor] = useState('t');
	// const [selectedSortBy, setSelectedSortBy] = useState(0);

	let ruta = getRuta();

	const verReport = () => {
		// var params = `${selectedGestor}/${selectedSortBy}`;
		var params = `${selectedGestor}`;
		window.open(`${ruta}/r-saldoscarterabygestor/${params}`);
	};

	return (
		<FormularioSelector>
			<SelectorGestor value={selectedGestor} onChange={setSelectedGestor} />

			<BotonGenerar onClick={verReport} />
		</FormularioSelector>
	);
};
export default SelectorSaldosCarteraByGestor;
